import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UserPanel from './userPanel';
import FooterPanel from './footerPanel';
import { MENUITEMS } from '../../../components/common/sidebar-component/menu';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import configDB from '../../../data/customizer/config';
import API from '../../../services/API';
import { Tool } from 'react-feather';
import { toast } from 'react-toastify';

const Sidebar = (props) => {
  const [margin, setMargin] = useState(0);
  const [width, setWidth] = useState(0);
  const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
  const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const [mainmenu, setMainMenu] = useState({ mainmenu: MENUITEMS });
  const wrapper = configDB.data.settings.sidebar.wrapper;
  const layout = useSelector((content) => content.Customizer.layout);
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  const CUSTOM_ATTENDANCE_ITEM = {
    title: 'Custom Attendance',
    icon: Tool,
    type: 'link',
    path: '/customAttendance',
    active: false,
  };

  // Fetch custom attendance enabled flag
  const fetchCustomAttendanceEnabled = () => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

    API.get('/customAttendance/enabled', { headers })
      .then((response) => {
        console.log(response)
        if (response.data.response_code === 1000) {
          const isEnabled = response.data.data?.enabled;
          if (isEnabled) {
            setMainMenu((prev) => {
              const exists = prev.mainmenu.some(
                (m) => m.title === 'Custom Attendance'
              );
              if (exists) return prev;
              return { mainmenu: [...prev.mainmenu, CUSTOM_ATTENDANCE_ITEM] };
            });
          }
        } else {
          toast.error(`${response.data.message}`, { autoClose: 5000 });
        }
      })
      .catch(() => {
        toast.error('Error checking custom attendance', { autoClose: 5000 });
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    var currentUrl = window.location.pathname;

    MENUITEMS.filter((items) => {
      if (items.path === currentUrl) setNavActive(items);
      if (!items.children) return false;
      items.children.filter((subItems) => {
        if (subItems.path === currentUrl) setNavActive(subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === currentUrl) {
            setNavActive(subSubItems);
            return true;
          } else {
            return false;
          }
        });
        return subItems;
      });
      return items;
    });

    const timeout = setTimeout(() => {
      const elmnt = document.getElementById('myDIV');
      const menuWidth = elmnt.offsetWidth;
      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
        setHideLeftArrowRTL(false);
      } else {
        setHideRightArrow(true);
        setHideLeftArrowRTL(true);
      }
    }, 500);

    // 🔹 Check custom attendance here
    fetchCustomAttendanceEnabled();

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeout);
    };
  }, []);

  function handleResize() {
    setWidth(window.innerWidth - 310);
  }

  const setNavActive = (item) => {
    MENUITEMS.filter((menuItem) => {
      if (menuItem !== item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true;
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (
            submenuItems.children &&
            submenuItems.children.includes(item)
          ) {
            menuItem.active = true;
            submenuItems.active = true;
            return true;
          } else {
            return false;
          }
        });
      }
      return menuItem;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const toggleNavActive = (item) => {
    if (isMobile) {
      document.querySelector('.page-main-header').classList.add('open');
      document.querySelector('.page-sidebar').classList.add('open');
    }

    if (!item.active) {
      MENUITEMS.forEach((a) => {
        if (MENUITEMS.includes(item)) a.active = false;
        if (!a.children) return false;
        a.children.forEach((b) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) return false;
          b.children.forEach((c) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
          });
        });
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById('myDIV');
    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;
    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrow(false);
    }
  };

  const scrollToLeftRTL = () => {
    if (margin <= -width) {
      setMargin((margin) => (margin += -width));
      setHideLeftArrowRTL(true);
    } else {
      setMargin((margin) => (margin += -width));
      setHideRightArrowRTL(false);
    }
  };

  const scrollToRightRTL = () => {
    const temp = width + margin;
    if (temp === 0) {
      setMargin(temp);
      setHideRightArrowRTL(true);
    } else {
      setMargin((margin) => (margin += width));
      setHideRightArrowRTL(false);
      setHideLeftArrowRTL(false);
    }
  };

  return (
    <Fragment>
      <div className="page-sidebar">
        <div className="main-header-left d-none d-lg-block">
          <div className="logo-wrapper compactLogo">
            {
              <Link to={`/dashboard`}>
                <img
                  className="blur-up lazyloaded"
                  src={'https://imgur.com/kEzgWVd.png'}
                  alt=""
                />
                <img
                  className="blur-up lazyloaded"
                  src={'https://imgur.com/kEzgWVd.png'}
                  alt=""
                  style={{ width: '60px', height: 'auto' }}
                />
              </Link>
            }
          </div>
        </div>
        <div className="sidebar custom-scrollbar">
          <UserPanel />
          <ul
            className="sidebar-menu"
            id="myDIV"
            style={
              wrapper === 'horizontal_sidebar'
                ? layout === 'rtl'
                  ? { marginRight: margin + 'px' }
                  : { marginLeft: margin + 'px' }
                : { margin: '0px' }
            }
          >
            <li
              className={`left-arrow ${
                layout === 'rtl'
                  ? hideLeftArrowRTL
                    ? 'd-none'
                    : ''
                  : hideLeftArrow
                  ? 'd-none'
                  : ''
              }`}
              onClick={
                wrapper === 'horizontal_sidebar' && layout === 'rtl'
                  ? scrollToLeftRTL
                  : scrollToLeft
              }
            >
              <i className="fa fa-angle-left"></i>
            </li>
            {mainmenu?.mainmenu?.map((menuItem, i) => (
              <li className={`${menuItem.active ? 'active' : ''}`} key={i}>
                {menuItem.sidebartitle ? (
                  <div className="sidebar-title">{menuItem.sidebartitle}</div>
                ) : (
                  ''
                )}
                {menuItem.type === 'sub' ? (
                  <a
                    className="sidebar-header"
                    href="#"
                    onClick={() => toggleNavActive(menuItem)}
                  >
                    <menuItem.icon />
                    <span>{t(menuItem.title)}</span>
                    <i className="fa fa-angle-right pull-right"></i>
                  </a>
                ) : (
                  ''
                )}
                {menuItem.type === 'link' ? (
                  <Link
                    to={`${menuItem.path}`}
                    className={`sidebar-header ${
                      menuItem.active ? 'active' : ''
                    }`}
                    onClick={() => toggleNavActive(menuItem)}
                  >
                    <menuItem.icon />
                    <span>{t(menuItem.title)}</span>
                    {menuItem.children ? (
                      <i className="fa fa-angle-right pull-right"></i>
                    ) : (
                      ''
                    )}
                  </Link>
                ) : (
                  ''
                )}
                {menuItem.children ? (
                  <ul
                    className={`sidebar-submenu ${
                      menuItem.active ? 'menu-open' : ''
                    }`}
                    style={
                      menuItem.active
                        ? { opacity: 1, transition: 'opacity 500ms ease-in' }
                        : {}
                    }
                  >
                    {menuItem.children.map((childrenItem, index) => (
                      <li
                        key={index}
                        className={
                          childrenItem.children
                            ? childrenItem.active
                              ? 'active'
                              : ''
                            : ''
                        }
                      >
                        {childrenItem.type === 'sub' ? (
                          <a
                            href="#"
                            onClick={() => toggleNavActive(childrenItem)}
                          >
                            <i className="fa fa-circle"></i>
                            {t(childrenItem.title)}{' '}
                            <i className="fa fa-angle-right pull-right"></i>
                          </a>
                        ) : (
                          ''
                        )}
                        {childrenItem.type === 'link' &&
                        (childrenItem.title !== 'Portal User' ||
                          localStorage.getItem('role') === '1') ? (
                          <Link
                            to={`${childrenItem.path}`}
                            className={childrenItem.active ? 'active' : ''}
                            onClick={() => toggleNavActive(childrenItem)}
                          >
                            <i className="fa fa-circle"></i>
                            {t(childrenItem.title)}
                          </Link>
                        ) : null}
                      </li>
                    ))}
                  </ul>
                ) : (
                  ''
                )}
              </li>
            ))}
            <li
              className={`right-arrow ${
                layout === 'rtl'
                  ? hideRightArrowRTL
                    ? 'd-none'
                    : ''
                  : hideRightArrow
                  ? 'd-none'
                  : ''
              }`}
              onClick={
                wrapper === 'horizontal_sidebar' && layout === 'rtl'
                  ? scrollToRightRTL
                  : scrollToRight
              }
            >
              <i className="fa fa-angle-right"></i>
            </li>
          </ul>
          <FooterPanel />
        </div>
      </div>
    </Fragment>
  );
};

export default Sidebar;
